import { createAction } from '@reduxjs/toolkit';
import api from '../../services/api';

export const newMessageTask = createAction('NEW_MESSAGE_TASK');

export const newMessageFlow = createAction('NEW_MESSAGE_FLOW');

export const clearTaskLog = createAction('CLEAR_TASK_LOG');

export const getTaskChat = createAction('GET_TASK_CHAT');

export const fetchTaskChat = ({ refId }) => {
  return (dispatch) =>
    api
      .get('/activedflows/chat/task/' + refId)
      .then((res) => dispatch(fetchTaskChatSucess({ data: res.data, refId })))
      .catch((err) => dispatch(fetchTaskChatFailure(err.message)));
};

const fetchTaskChatSucess = (payload) => getTaskChat(payload);

const fetchTaskChatFailure = (err) => {
  console.error(err.message);
};

export const handleNewMessage = ({
  userId,
  ref,
  username,
  message,
  type,
}) => {
  return (dispatch) =>
    api
      .post('/activedflows/chat/new', {
        userId,
        ref,
        username,
        message,
        type,
      })
      .then((res) => dispatch(newMessageSucess(res.data)))
      .catch((err) => dispatch(newMessageFailure(err.message)));
};

const newMessageSucess = (payload) => {
  const chatMessage = payload.chatMessage;
  if (chatMessage.type === 'task') {
    return newMessageTask(payload);
  } else {
    return newMessageFlow(payload);
  }
};

const newMessageFailure = (error) => {
  console.error(error);
};
